import { render, staticRenderFns } from "./MriBrain_v2.vue?vue&type=template&id=209cf6b9&"
import script from "./MriBrain_v2.vue?vue&type=script&lang=ts&"
export * from "./MriBrain_v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('209cf6b9')) {
      api.createRecord('209cf6b9', component.options)
    } else {
      api.reload('209cf6b9', component.options)
    }
    module.hot.accept("./MriBrain_v2.vue?vue&type=template&id=209cf6b9&", function () {
      api.rerender('209cf6b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/advanced/MriBrain_v2.vue"
export default component.exports